import React from 'react';

const TagSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.6 3l9 9-8.6 8.6-9-9V3h8.6zm.4-1H2v10l10 10 10-10L12 2z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 3c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
        />
    </svg>
);

TagSvg.displayName = 'TagSvg';
export default TagSvg;
